{
  "main": {
    "Dashboards": "Dashboard",
    "Properties": "Proprietà",
    "Asset Management": "Gestione degli asset",
    "Controls": "Controlli",
    "Property Services": "Servizi immobiliari",
    "Alarms": "Allarmi",
    "Reports": "Report",
    "Settings": "Impostazioni",
    "Energy Dashboard": "Dashboard energetica"
  },
  "properties": {
    "You have {count} unread alerts_one": "Hai {{count}} avviso non letto",
    "You have {count} unread alerts_other": "Hai {{count}} avvisi non letti",
    "All installations are running smoothly.": "Tutte le installazioni funzionano correttamente.",
    "Choose an address first": "Scegli prima un indirizzo",
    "Properties": "Proprietà",
    "New Property": "Nuova proprietà",
    "Edit Property": "Modifica proprietà",
    "Delete Property": "Elimina proprietà",
    "Remove": "Rimuovi",
    "Are you sure you want to remove property": "Sei sicuro di voler rimuovere la proprietà",
    "You cannot delete the property": "Non puoi eliminare la proprietà",
    "because the following items are blocking deletion.": "perché i seguenti elementi bloccano l'eliminazione.",
    "To delete the property, you must first remove the following items.": "Per eliminare la proprietà, devi prima rimuovere i seguenti elementi.",
    "Devices": "Dispositivi",
    "Dashboard": "Dashboard",
    "Widgets": "Widget",
    "Attention": "Attenzione",
    "Current Month's Consumption": "Consumo del mese corrente",
    "Actual Costs": "Costi mensili effettivi",
    "Name": "Nome",
    "Address": "Indirizzo",
    "Timezone": "Fuso orario",
    "Currency": "Valuta",
    "Contacts": "Contatti",
    "Select Users": "Seleziona utenti",
    "Surname": "Cognome",
    "Email": "Email",
    "Role": "Ruolo",
    "Phone": "Telefono",
    "Choose an Image": "Scegli un'immagine",
    "Heated Floor Area": "Superficie del pavimento riscaldato",
    "Value must be positive": "Il valore deve essere positivo",
    "Heating System Type": "Tipo di sistema di riscaldamento",
    "Electricity": "Elettricità",
    "Natural Gas": "Gas naturale",
    "District Heating": "Teleriscaldamento",
    "Oil": "Olio",
    "Heat Pump Air": "Pompa di calore aria",
    "Heat Pump Earth": "Pompa di calore terra",
    "Category": "Categoria",
    "Healthcare": "Sanità",
    "Industrial": "Industriale",
    "Hotel": "Hotel",
    "Office": "Ufficio",
    "Office/Residential": "Ufficio/Residenziale",
    "Other": "Altro",
    "Residential": "Residenziale",
    "Retail": "Commercio al dettaglio",
    "Retail/office": "Commercio al dettaglio/ufficio",
    "Warehouse": "Magazzino",
    "Heating Energy Consumption": "Consumo di energia per il riscaldamento",
    "Electrical Energy Consumption": "Consumo di energia elettrica",
    "Construction Year": "Anno di costruzione",
    "Please enter a valid year (e.g. 2020)": "Inserisci un anno valido (es. 2020)",
    "Today's Consumption": "Consumo odierno",
    "Sort: {label}": "Ordina: {{label}}",
    "Priority": "Priorità",
    "Alphabetic (A-Z)": "Alfabetico (A-Z)",
    "Alphabetic (Z-A)": "Alfabetico (Z-A)",
    "cancel": "annulla",
    "Create": "Crea",
    "Save": "Salva",
    "Update": "Aggiorna",
    "This field is required": "Questo campo è obbligatorio",
    "{name} was created successfully": "{{name}} è stato creato con successo",
    "{name} was updated successfully": "{{name}} è stato aggiornato con successo",
    "Property deleted successfully": "Proprietà eliminata con successo",
    "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
    "An error occurred while updating {name}": "Si è verificato un errore durante l'aggiornamento di {{name}}",
    "An error occurred while deleting property": "Si è verificato un errore durante l'eliminazione della proprietà",
    "Back": "indietro",
    "Next": "Avanti",
    "Add Key Contact": "Aggiungi contatto chiave",
    "Add Contacts": "Aggiungi Contatti",
    "Phone is not valid (e.g., +39...)": "Il numero di telefono non è valido (es., +39...)",
    "Email is not valid (e.g., user@example.com)": "L'email non è valida (es. user@example.com)",
    "Address is not valid": "L'indirizzo non è valido",
    "Please fill in all required fields before moving forward": "Compila tutti i campi obbligatori prima di procedere",
    "Some fields are not valid": "Alcuni campi non sono validi",
    "Add Gateway": "Aggiungi Gateway"
  },
  "property_details": {
    "Properties": "Proprietà",
    "Property Details": "Dettagli proprietà",
    "You have a total of {tot} events, {totAlerts} of which requires your attention": "Hai un totale di {{tot}} eventi, {{totAlerts}} dei quali richiedono la tua attenzione",
    "You have a total of {tot} devices, {totAlerts} of which requires your attention": "Hai un totale di {{tot}} dispositivi, {{totAlerts}} dei quali richiedono la tua attenzione",
    "Property not found": "Proprietà non trovata",
    "Today's Details": "Dettagli odierni",
    "Current Month's Consumption": "Consumo del mese corrente",
    "Today's Consumption": "Consumo odierno",
    "Actual costs": "Costi mensili effettivi",
    "Key contacts": "Contatti chiave",
    "Events": "Eventi",
    "Devices": "Dispositivi",
    "tabs": {
      "property_events": {
        "Name": "Nome",
        "State": "Stato",
        "Last update": "Ultimo aggiornamento",
        "Condition": "Condizione",
        "Offline": "Offline",
        "Okay": "Ok",
        "In alarm": "In allarme"
      },
      "property_devices": {
        "Name": "Nome",
        "State": "Stato",
        "Last update": "Ultimo aggiornamento",
        "Condition": "Condizione",
        "Offline": "Offline",
        "Okay": "Ok",
        "In alarm": "In allarme",
        "Category": "Categoria",
        "Communication Protocol": "Protocollo di comunicazione",
        "CURRENT_SENSOR": "Sensore di corrente",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "AC [A]",
        "DC_A": "DC [A]",
        "ACTIVE_POWER_TOTAL_W": "Potenza attiva totale [W]",
        "ACTIVE_ENERGY_TOTAL_WH": "Energia attiva totale [kWh]",
        "Groups": "Gruppi",
        "N. Of alarms to be checked": "N. di allarmi da controllare",
        "N. Of automations to be checked": "N. di automazioni da controllare"
      }
    }
  },
  "asset_management": {
    "Asset Management": "Gestione degli asset",
    "Devices": "Dispositivi",
    "Groups": "Gruppi",
    "Add Device": "Aggiungi dispositivo",
    "New Group": "Nuovo gruppo",
    "You are managing a total of {tot} devices, of which {connected} are «connected», {offline} «offline», {noCommunication} with no communication": "Stai gestendo un totale di {{tot}} dispositivi, di cui {{connected}} sono «connessi», {{offline}} «offline», {{noCommunication}} senza comunicazione",
    "You have a total of {tot} groups configured": "Hai un totale di {{tot}} gruppi configurati",
    "tabs": {
      "devices": {
        "Offline": "Offline",
        "Okay": "Ok",
        "Needs intervention": "Necessita intervento",
        "Name": "Nome",
        "Status": "Stato",
        "Category": "Categoria",
        "Group": "Gruppo",
        "Property": "Proprietà",
        "Device Name": "Nome dispositivo",
        "Communication Protocol": "Protocollo di comunicazione",
        "Power": "Accensione",
        "Temperature": "Temperatura",
        "Asset not found": "Asset non trovato",
        "n/a": "n/d",
        "Manufacturer": "Produttore",
        "Model": "Modello",
        "S/N": "N/S",
        "Most Recent Events": "Eventi più recenti",
        "State": "Stato",
        "Last Update": "Ultimo aggiornamento",
        "Condition": "Condizione",
        "see all events": "vedi tutti gli eventi",
        "CURRENT_SENSOR": "Sensore di corrente",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "AC [A]",
        "DC_A": "DC [A]",
        "ACTIVE_POWER_TOTAL_W": "Potenza attiva totale [W]",
        "ACTIVE_ENERGY_TOTAL_WH": "Energia attiva totale [kWh]",
        "Auxiliary Contact": "Contatto ausiliario",
        "Meter Linky": "Meter Linky",
        "Meter P1": "Meter P1",
        "Third Party RTU": "Third Party RTU",
        "Third Party TCP": "Third Party TCP",
        "asset_details": {
          "Status": "Stato",
          "Last update": "Ultimo aggiornamento",
          "Last update by": "Ultimo aggiornamento da",
          "Condition": "Condizione",
          "Offline": "Offline",
          "Okay": "Ok",
          "Needs intervention": "Necessita intervento",
          "Current status": "Stato attuale",
          "Device details": "Dettagli dispositivo",
          "Device control": "Controllo dispositivo",
          "Device firmware": "Firmware dispositivo",
          "Latest Firmware Update": "Ultimo aggiornamento firmware",
          "Current Firmware": "Firmware attuale",
          "Updating firmware...": "Aggiornamento firmware in corso...",
          "New FW update available": "Nuovo aggiornamento firmware disponibile",
          "Updated to the latest firmware": "Aggiornato all'ultimo firmware",
          "Update firmware": "Aggiorna firmware",
          "On": "Acceso",
          "Off": "Spento",
          "CLOSED": "Chiuso",
          "OPEN": "Aperto",
          "CURRENT_SENSOR": "Sensore di corrente",
          "ENERGY_METER": "Energy Meter",
          "I_O_MODULE": "I/O module",
          "INS_S_H": "INS-S/H",
          "MODBUS": "Modbus",
          "SCU200": "SCU200",
          "METER_W_MBUS": "Meter WMBus",
          "METER_LINKY": "Meter Linky",
          "METER_P1": "Meter P1",
          "THIRD_PARTY_RTU": "Third Party RTU",
          "THIRD_PARTY_TCP": "Third Party TCP",
          "TRMS_A": "TRMS [A]",
          "AC_A": "AC [A]",
          "DC_A": "DC [A]",
          "ACTIVE_POWER_TOTAL_W": "Potenza attiva totale [W]",
          "ACTIVE_ENERGY_TOTAL_WH": "Energia attiva totale [kWh]",
          "Current Consumption": "Consumo medio di oggi",
          "Highest Peak load current month": "Picco massimo di consumo del mese",
          "Average Monthly consumption": "Consumo medio mensile",
          "Total monthly cost": "Costo totale mensile",
          "Name": "Nome",
          "Manufacturer": "Produttore",
          "Model": "Modello",
          "Serial Number": "Numero di serie",
          "Service Contract": "Contratto di servizio",
          "Installation Date": "Data di installazione",
          "Location": "Posizione",
          "Coordinates": "Coordinate",
          "Power": "Potenza",
          "Charging speed": "Velocità di ricarica",
          "Back to devices": "Torna ai dispositivi",
          "Export history": "Esporta cronologia",
          "From": "Da",
          "To": "A",
          "Generate report": "Genera report",
          "Low": "Basso",
          "High": "Alto",
          "cancel": "annulla",
          "Apply": "Applica",
          "File generated successfully": "File generato con successo",
          "An error occurred while generating export file": "Si è verificato un errore durante la generazione del file di esportazione",
          "Edit device": "Modifica dispositivo",
          "Save": "Salva",
          "Latitude": "Latitudine",
          "Longitude": "Longitudine",
          "Device details updated": "Dettagli del dispositivo aggiornati",
          "An error occurred while updating device details": "Si è verificato un errore durante l'aggiornamento dei dettagli del dispositivo",
          "User": "Utente",
          "Groups": "Gruppi",
          "Automations": "Automazioni",
          "Alarms": "Allarmi",
          "Port_1_State": "Stato porta 1",
          "Port_2_State": "Stato porta 2",
          "Port_3_State": "Stato porta 3",
          "Port_4_State": "Stato porta 4",
          "TripStatus": "Stato trip",
          "MCBTemperature": "Temperatura MCB"
        }
      },
      "groups": {
        "Name": "Nome",
        "Multiple properties": "Proprietà multiple",
        "Consumption": "Consumo",
        "Property": "Proprietà",
        "Description": "Descrizione",
        "cancel": "annulla",
        "Create": "Crea",
        "New Group": "Nuovo gruppo",
        "Search" : "Cerca...",
        "Preview": "Anteprima",
        "Assets": "Asset",
        "Select at least one asset": "Seleziona almeno un asset",
        "{name} was created successfully": "{{name}} è stato creato con successo",
        "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
        "{name} was updated successfully": "{{name}} è stato aggiornato con successo",
        "An error occurred while updating {name}": "Si è verificato un errore durante l'aggiornamento di {{name}}",
        "Save": "Salva",
        "Are you sure you want to remove group": "Sei sicuro di voler rimuovere il gruppo",
        "Group removed successfully": "Gruppo rimosso con successo",
        "Remove": "Rimuovi",
        "Edit Group": "Modifica Gruppo",
        "Remove Group": "Rimuovi Gruppo"
      }
    }
  },
  "controls": {
    "Controls": "Controlli",
    "You have no automations configured yet": "Non hai ancora configurato automazioni",
    "You have a total of {tot} devices to be controlled": "Hai un totale di {{tot}} dispositivi da controllare",
    "You have a total of {tot} automations configured. In the last 5 days, {lastRan} have run and {failed} were not possible to be executed": "Hai un totale di {{tot}} automazioni configurate. Negli ultimi 5 giorni, {{lastRan}} sono state eseguite e {{failed}} non sono state possibili da eseguire",
    "Manual Control": "Controllo manuale",
    "Automations": "Automazioni",
    "New Automation": "Nuova automazione",
    "tabs": {
      "manual_control": {
        "Status": "Stato",
        "Offline": "Offline",
        "Connected": "Connesso",
        "Needs intervention": "Richiede intervento",
        "Device Name": "Nome dispositivo",
        "Device Category": "Categoria dispositivo",
        "Group": "Gruppo",
        "Name": "Nome",
        "Off/On": "Spento/Acceso",
        "Action": "Azione",
        "Temperature": "Temperatura",
        "CURRENT_SENSOR": "Sensore di corrente",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "Charging Speed": "Velocità di ricarica",
        "Are you sure that you want to change the status from {fromStatus} to {toStatus} of the": "Sei sicuro di voler cambiare lo stato da {{fromStatus}} a {{toStatus}} del",
        "cancel": "annulla",
        "Turn {toStatus}": "Imposta su {{toStatus}}",
        "{deviceName} was turned {devicePowerStatus} successfully": "{{deviceName}} è stato impostato su {{devicePowerStatus}} con successo"
      },
      "automations": {
        "New Automation": "Nuova automazione",
        "Edit Automation": "Modifica automazione",
        "cancel": "annulla",
        "Create": "Crea",
        "Save": "Salva",
        "Next": "Avanti",
        "Back": "indietro",
        "Apply": "Applica",
        "Trigger": "Innesco",
        "On selected period": "Nel periodo selezionato",
        "Start date": "Data inizio",
        "End date": "Data fine",
        "Automation Name": "Nome automazione",
        "Name": "Nome",
        "Conditions": "Condizioni",
        "Type": "Tipo",
        "Select the type of asset you would like to create an automation for": "Seleziona il tipo di asset per cui desideri creare un'automazione",
        "Properties": "Proprietà",
        "Groups": "Gruppi",
        "Devices": "Dispositivi",
        "Search": "Cerca",
        "Device": "Dispositivo",
        "Event Type": "Tipo di evento",
        "Measure": "Misura",
        "Threshold": "Soglia",
        "Add another condition": "Aggiungi un'altra condizione",
        "Time delay (seconds)": "Ritardo temporale (secondi)",
        "Delay": "Ritardo",
        "Alarm": "Allarme",
        "Send event": "Invia evento",
        "Enabled": "Abilitato",
        "Device Details": "Dettagli dispositivo",
        "Port": "Porta",
        "Action": "Azione",
        "Please fill in all required fields before moving forward": "Compila tutti i campi obbligatori prima di procedere",
        "You have to exit edit mode to proceed": "Devi uscire dalla modalità di modifica per procedere",
        "Please save or cancel changes to current condition before adding a new one": "Salva o annulla le modifiche alla condizione attuale prima di aggiungerne una nuova",
        "Please save or cancel changes to current condition before editing another one": "Salva o annulla le modifiche alla condizione attuale prima di modificarne un'altra",
        "Please save or cancel changes to current condition before removing another one": "Salva o annulla le modifiche alla condizione attuale prima di rimuoverne un'altra",
        "Are you sure you want to remove condition": "Sei sicuro di voler rimuovere la condizione",
        "Please remove duplicated conditions before proceeding": "Rimuovi le condizioni duplicate prima di procedere",
        "Remove": "Rimuovi",
        "No": "No",
        "Yes": "Sì",
        "WARNING: This action will result in losing any unsaved changes.<br>Do you want to save changes before continuing": "ATTENZIONE: Questa azione comporterà la perdita di eventuali modifiche non salvate.<br>Vuoi salvare le modifiche prima di continuare",
        "Please save or cancel changes to current condition before leaving this step": "Salva o annulla le modifiche alla condizione attuale prima di procedere",
        "{name} was created successfully": "{{name}} è stata creata con successo",
        "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
        "{name} was updated successfully": "{{name}} è stata aggiornata con successo",
        "An error occurred while updating {name}": "Si è verificato un errore durante l'aggiornamento di {{name}}",
        "Configured": "Configurata",
        "Logs": "Log",
        "This field is required": "Questo campo è obbligatorio",
        "Invalid date": "Data non valida",
        "tabs": {
          "configured": {
            "Automation Name": "Nome automazione",
            "Show with alarm only": "Mostra solo con allarme",
            "Show enabled automations only": "Mostra solo automazioni abilitate",
            "Yes": "Sì",
            "No": "No",
            "Name": "Nome",
            "When": "Quando",
            "If": "Se",
            "Then": "Allora",
            "Alarm": "Allarme",
            "Last update": "Ultimo aggiornamento",
            "Failed": "Fallito",
            "years ago": "anni fa",
            "months ago": "mesi fa",
            "days ago": "giorni fa",
            "hours ago": "ore fa",
            "minutes ago": "minuti fa",
            "seconds ago": "secondi fa",
            "just now": "proprio ora",
            "Enabled": "Abilitato",
            "Properties": "Proprietà",
            "Groups": "Gruppi",
            "Devices": "Dispositivi",
            "Conditions": "Condizioni",
            "New Automation - IF": "Nuova automazione - SE",
            "Type": "Tipo",
            "Device": "Dispositivo",
            "Event Type": "Tipo di evento",
            "Measure": "Misura",
            "Threshold": "Soglia",
            "Add another condition": "Aggiungi un'altra condizione",
            "Time delay (seconds)": "Ritardo temporale (secondi)",
            "Delay": "Ritardo",
            "Send event": "Invia evento",
            "New Automation - Then": "Nuova automazione - Allora",
            "Device Details": "Dettagli dispositivo",
            "Port": "Porta",
            "Action": "Azione",
            "cancel": "annulla",
            "Create": "Crea",
            "Back": "indietro",
            "Are you sure that you want to {action}": "Sei sicuro di voler {{action}}",
            "Enable": "Abilita",
            "Disable": "Disabilita",
            "Set in alarm": "Imposta in allarme",
            "set in alarm": "impostare in allarme",
            "all selected items": "tutti gli elementi selezionati",
            "disable": "disabilitare",
            "enable": "abilitare",
            "remove": "rimuovere",
            "enabled": "abilitato",
            "disabled": "disabilitato",
            "enabled_other": "abilitate",
            "disabled_other": "disabilitate",
            "enabling": "abilitando",
            "disabling": "disabilitando",
            "Remove": "Rimuovi",
            "Automation {action} successfully": "Automazione {{action}} con successo",
            "An error occurred while {action} automation": "Si è verificato un errore durante {{action}} l'automazione",
            "Selected automations are already {status}": "Le automazioni selezionate sono già {{status}}",
            "Selected automations are already in alarm status": "Le automazioni selezionate sono già in stato di allarme",
            "Automation deleted successfully": "Automazione eliminata con successo",
            "An error occurred while deleting the automation": "Si è verificato un errore durante l'eliminazione dell'automazione",
            "Automation set successfully in alarm": "Automazione impostata con successo in allarme",
            "An error occurred while setting automation in alarm": "Si è verificato un errore durante l'impostazione dell'automazione in allarme",
            "Group": "Gruppo",
            "Property": "Proprietà"
          },
          "logs": {
            "Date": "Data",
            "cancel": "annulla",
            "Apply": "Applica",
            "Export": "Esporta",
            "Start date": "Data inizio",
            "End date": "Data fine",
            "Name": "Nome",
            "When": "Quando",
            "If": "Se",
            "Then": "Allora",
            "Automation time": "Tempo automazione",
            "Alarm": "Allarme",
            "Properties": "Proprietà",
            "Groups": "Gruppi",
            "Devices": "Dispositivi",
            "Status": "Stato",
            "Successfully": "Con successo",
            "Failure": "Errore",
            "Yes": "Sì",
            "No": "No",
            "File exported successfully": "File esportato con successo",
            "An error occurred while exporting file": "Si è verificato un errore durante l'esportazione del file",
            "Group": "Gruppo",
            "Property": "Proprietà",
            "Device": "Dispositivo"
          }
        }
      }
    }
  },
  "dashboards": {
    "You have {count} unread alerts_one": "Hai <a href='alarms/list' class='underline text-blue-600'>{{count}} allarme attivo</a>.",
    "You have {count} unread alerts_other": "Hai <a href='alarms/list' class='underline text-blue-600'>{{count}} allarmi attivi</a>.",
    "No alarms require your attention.": "Nessun allarme richiede la tua attenzione.",
    "All installations are running smoothly.": "Tutte le installazioni funzionano correttamente.",
    "Create new dashboard": "Crea nuova dashboard",
    "Stop editing": "Termina modifica",
    "Add widget": "Aggiungi widget",
    "Dashboard deleted successfully": "Dashboard eliminata con successo",
    "An error occurred while deleting the dashboard": "Si è verificato un errore durante l'eliminazione della dashboard",
    "Are you sure you want to delete \"{name}\"?": "Sei sicuro di voler eliminare \"{{name}}\"?",
    "Delete dashboard": "Elimina dashboard",
    "An error occurred while pinning the dashboard": "Si è verificato un errore durante il fissaggio della dashboard",
    "Export": "Esporta",
    "File generated successfully": "File generato con successo",
    "An error occurred while generating export file": "Si è verificato un errore durante la generazione del file di esportazione",
    "modal": {
      "Create": "Crea",
      "cancel": "annulla",
      "Name": "Nome",
      "The name of your new dashboard, this will also serve as the dashboard title": "Il nome della nuova dashboard, che servirà anche come titolo della dashboard",
      "An error occurred while creating the dashboard": "Si è verificato un errore durante la creazione della dashboard",
      "Dashboard created successfully": "Dashboard creata con successo",
      "Create Dashboard": "Crea Dashboard",
      "Dashboard updated successfully": "Dashboard aggiornata con successo",
      "An error occurred while updating the dashboard": "Si è verificato un errore durante l'aggiornamento della dashboard",
      "Update Dashboard": "Aggiorna Dashboard",
      "Save": "Salva"
    },
    "side_panel": {
      "New widget": "Nuovo widget",
      "Widget type": "Tipo di widget",
      "No results found": "- Nessun risultato trovato ",
      "Search": "Cerca...",
      "Number": "Numero",
      "Chart": "Grafico",
      "Benchmark": "Confronto",
      "Alarms/Events": "Allarmi/Eventi",
      "Solar": "Solare",
      "Filter": "Filtro",
      "Map": "Mappa",
      "Energy monitoring": "Monitoraggio energetico",
      "Non-electrical parameters": "Parametri non elettrici",
      "Cost management": "Gestione dei costi",
      "Coming soon": "In arrivo",
      "Alarms monitoring": "Monitoraggio allarmi",
      "Control": "Controllo",
      "Automations": "Automazioni",
      "Data analysis": "Analisi dati",
      "Asset monitoring": "Monitoraggio risorse",
      "Sustainability": "Sostenibilità",
      "Properties": "Proprietà",
      "Widget for metrics or instantaneous values.": "Widget per metriche o valori istantanei.",
      "Widget for visualizing a key parameter.": "Widget per la visualizzazione di un parametro chiave.",
      "Widget for benchmark comparisons even with external sources.": "Widget per confronti di benchmark anche con fonti esterne.",
      "Widget for visualizing events and alarms.": "Widget per la visualizzazione di eventi e allarmi.",
      "Widget for visualizing solar generation.": "Widget per la visualizzazione della generazione solare.",
      "Widget for enabling quick and frequent manual control actions.": "Widget per abilitare azioni di controllo manuali rapide e frequenti.",
      "Widget for filtering the dashboard details.": "Widget per filtrare i dettagli della dashboard.",
      "Widget for geolocation visualization.": "Widget per la visualizzazione della geolocalizzazione.",
      "{type} widget": "Widget {{type}}",
      "Widget selection": "Selezione widget",
      "An error occurred while creating the widget": "Si è verificato un errore durante la creazione del widget",
      "Widget created successfully": "Widget creato con successo",
      "Widget duplicated successfully": "Widget duplicato con successo",
      "Create": "Crea",
      "Update": "Aggiorna",
      "cancel": "annulla",
      "Metric": "Metrica",
      "currentTrms": "TRMS",
      "currentAc": "AC",
      "currentDc": "DC",
      "activePowerTotal": "Potenza attiva",
      "activeEnergyTotal": "Energia attiva",
      "Metric type": "Tipo di metrica",
      "Assets": "Risorse",
      "Metric details": "Dettagli metrica",
      "Preview": "Anteprima",
      "An error occurred while updating the widget": "Si è verificato un errore durante l'aggiornamento del widget",
      "Widget updated successfully": "Widget aggiornato con successo",
      "Save": "Salva",
      "Electrical values": "Valori elettrici",
      "Data presentation of general electrical values": "Visualizza i valori elettrici generali per proprietà, gruppi o dispositivi.",
      "Title": "Titolo",
      "Property / Group": "Proprietà / Gruppo",
      "Groups": "Gruppi",
      "No matches found": "Nessun risultato trovato",
      "Type": "Tipo",
      "Auxiliary Contact": "Contatto ausiliario",
      "Meter WMbus": "Contatore WMbus",
      "Meter Linky": "Contatore Linky",
      "Meter P1": "Contatore P1",
      "Third Party RTU": "RTU di terze parti",
      "Third Party TCP": "TCP di terze parti",
      "Devices": "Dispositivi",
      "Display": "Visualizzazione",
      "Chart (linear)": "Grafico (lineare)",
      "Chart (column)": "Grafico (a colonne)",
      "Chart (donut)": "Grafico (a ciambella)",
      "Table": "Tabella",
      "Gauge": "Indicatore",
      "Min": "Min",
      "Max": "Max",
      "Target (min)": "Obiettivo (min)",
      "Target (max)": "Obiettivo (max)",
      "Y axis": "Asse Y",
      "Data presentation of values from category \"Energy values\"": "Visualizza i valori energetici per proprietà, gruppi o dispositivi.",
      "Energy values": "Valori energetici",
      "Power quality values": "Valori di qualità dell'energia",
      "Data presentation of values from category \"Power Quality Values\"": "Visualizza i valori di qualità dell'energia per proprietà, gruppi o dispositivi.",
      "Custom values": "Valori personalizzati",
      "Data presentation of values from other categories": "Visualizza parametri specifici dei dispositivi per proprietà, gruppi o dispositivi.",
      "Cost benchmark": "Confronto dei costi",
      "Cost comparison data between properties, groups or devices": "Confronta i costi tra proprietà, gruppi o dispositivi.",
      "Device": "Dispositivo",
      "Group": "Gruppo",
      "Property": "Proprietà",
      "Criteria": "Criteri",
      "Date": "Data",
      "Timeframe": "Intervallo di tempo",
      "Today": "Oggi",
      "Yesterday": "Ieri",
      "Last week": "Settimana scorsa",
      "Last month": "Mese scorso",
      "Last year": "Anno scorso",
      "Specific date": "Data specifica",
      "Cost details per property or group": "Fornisce un dettaglio dei costi per proprietà o gruppi in un intervallo di tempo specifico.",
      "Energy cost breakdown": "Ripartizione dei costi energetici",
      "Max / Min values": "Valori Max / Min",
      "Data visualization of Max, Min and Avg values for established device conditions": "Visualizza i valori massimi, minimi e medi per proprietà, gruppi o dispositivi in un intervallo di tempo specifico.",
      "Max / Min": "Max / Min",
      "Energy consumption": "Consumo energetico",
      "Data presentation of \"Energy values\" between different types of devices": "Visualizza i valori di consumo energetico per proprietà, gruppi o dispositivi.",
      "Data presentation of Water / Gas data": "Visualizza la configurazione del consumo di gas o acqua.",
      "Water / Gas": "Acqua / Gas",
      "Contracts & Tariffs": "Contratti e Tariffe",
      "Data presentation of contracts & tariffs values": "Visualizza la configurazione corrente dei contratti e delle tariffe esistenti.",
      "Contract": "Contratto",
      "Tariff": "Tariffa",
      "Data presentation of number of alarms to be acknowledged": "Visualizza il numero di allarmi da riconoscere per proprietà.",
      "N. of alarms": "N. di allarmi",
      "Data presentation of alarms triggered": "Monitora gli allarmi attivati per proprietà e intervallo di tempo.",
      "Alarm log": "Registro allarmi",
      "Columns": "Colonne",
      "Data presentation of automations that have occurred": "Monitora le automazioni eseguite per proprietà e intervallo di tempo.",
      "Automations log": "Registro automazioni",
      "Visualization of the current devices status": "Visualizza lo stato attuale dei dispositivi.",
      "Device status": "Stato dispositivo",
      "Online events": "Eventi online",
      "Data presentation of online events": "Monitora i cambiamenti di stato dei dispositivi in un intervallo di tempo specifico.",
      "CO2 Emissions": "Emissioni di CO2",
      "Measure the impact of your overall consumption": "Traccia l'impatto complessivo del consumo.",
      "Visualization": "Visualizzazione",
      "Average": "Media",
      "Single": "Singolo",
      "Conversion factor": "Fattore di conversione",
      "Targets": "Obiettivi",
      "Select at least one property": "Seleziona almeno una proprietà",
      "Widget for customizable text options": "Visualizza la configurazione del consumo di gas o acqua.",
      "Text": "Testo",
      "Geolocation Visualization": "Visualizzazione della geolocalizzazione",
      "Location": "Posizione",
      "Actual vs Target Values": "Valori attuali vs obiettivi",
      "Comparison of real values vs targeted ones": "Confronta i valori reali con quelli obiettivo.",
      "Metrics": "Metriche",
      "N/A": "N/D",
      "This field is required": "Questo campo è obbligatorio",
      "Please fill all required fields": "Compila tutti i campi obbligatori",
      "Are you sure you want to remove device": "Sei sicuro di voler rimuovere il dispositivo?",
      "You cannot delete device": "Non puoi eliminare il dispositivo",
      "To delete the device, you must first remove the following items.": "Per eliminare il dispositivo, devi prima rimuovere i seguenti elementi.",
      "Dashboard": "Dashboard",
      "Widgets": "Widgets",
      "Dashboards": "Dashboard",
      "Alarms": "Allarmi",
      "Contracts": "Contratti",
      "Attention": "Attenzione",
      "Maximum 10 devices can be selected": "È possibile selezionare un massimo di 10 dispositivi"
    },
    "currentTrms": "TRMS",
    "currentAc": "AC",
    "currentDc": "DC",
    "activePowerTotal": "Potenza effettiva",
    "activeEnergyTotal": "Energia effettiva",
    "Do you want to delete this widget?": "Vuoi eliminare questo widget?",
    "Warning": "Avviso",
    "An error occurred while deleting the widget": "Si è verificato un errore durante l'eliminazione del widget",
    "Widget deleted": "Widget eliminato",
    "On": "Acceso",
    "Off": "Spento",
    "Refresh rate": "Frequenza di aggiornamento",
    "Refresh rate was updated successfully": "La frequenza di aggiornamento è stata aggiornata con successo",
    "Minutes {{minutes}}": "{{minutes}} Minuti",
    "max_min_values": {
      "Min": "Min",
      "Max": "Max",
      "Avg": "Media"
    },
    "contracts_and_tariffs": {
      "Cost": "Costo",
      "Total cost of contract divided by tariffs:": "Costo totale del contratto diviso per tariffe:",
      "Name": "Nome",
      "Type": "Tipo",
      "Tag": "Tag",
      "Devices": "Dispositivi",
      "Tariffs": "Tariffe",
      "Total cost": "Costo totale",
      "Usage": "Utilizzo",
      "You don't have permission to view this property or group": "Non hai il permesso di visualizzare questa proprietà o gruppo"
    },
    "alarm_log": {
      "Name": "Nome",
      "State": "Stato",
      "Condition": "Condizione",
      "Time": "Ora",
      "Property": "Proprietà",
      "Groups": "Gruppi",
      "NAME": "Nome",
      "STATE": "Stato",
      "CONDITION": "Condizione",
      "TIME": "Ora",
      "PROPERTY": "Proprietà",
      "GROUPS": "Gruppi"
    },
    "automations_log": {
      "Name": "Nome",
      "Conditions (WHEN/IF/THEN)": "Condizioni (QUANDO/SE/ALLORA)",
      "Time": "Ora",
      "Property": "Proprietà",
      "Groups": "Gruppi"
    },
    "online_events": {
      "Name": "Nome",
      "Device": "Dispositivo",
      "Category": "Categoria",
      "Status": "Stato",
      "Date and Time": "Data e Ora"
    },
    "list_with_target_widget": {
      "Selected properties": "Proprietà selezionate",
      "Name": "Nome",
      "Value": "Valore",
      "CO2 emissions": "Emissioni di CO<sub>2</sub>",
      "Target": "Obiettivo",
      "g CO2/kWh": "g CO<sub>2</sub>/kWh"
    },
    "number_and_list_widget": {
      "Number of alarms to be acknowledged": "Numero di allarmi da controllare",
      "Properties": "Proprietà"
    },
    "DEVICE_NAME": "Nome dispositivo",
    "NAME": "Nome",
    "STATE": "Stato",
    "CONDITION": "Condizione",
    "CONDITIONS": "Condizioni",
    "TIME": "Ora",
    "PROPERTY": "Proprietà",
    "GROUPS": "Gruppi",
    "DATEANDTIME": "Data e Ora",
    "You don't have permission to view this property or group": "Non hai il permesso di visualizzare questa proprietà o gruppo",
    "Pin": "Fissa"
  },
  "reports": {
    "Reports": "Report",
    "You have a total of {tot} reports available.": "Hai un totale di {{tot}} report disponibili.",
    "New Report": "Nuovo Report",
    "{name} was created successfully": "{{name}} è stato messo in coda con successo.",
    "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
    "Name": "Nome",
    "Date": "Data",
    "Author": "Autore",
    "Category": "Categoria",
    "Format": "Formato",
    "Open": "Apri",
    "Download": "Scarica",
    "cancel": "annulla",
    "Create": "Crea",
    "Apply": "Applica",
    "Report Name": "Nome Report",
    "Template": "Modello",
    "Interval": "Intervallo",
    "From": "Da",
    "To": "A",
    "Start date": "Data di inizio",
    "End date": "Data di fine",
    "Properties": "Proprietà",
    "Search": "Cerca",
    "This field is required": "Questo campo è obbligatorio",
    "An error occurred while exporting file": "Si è verificato un errore durante l'esportazione del file.",
    "File exported successfully": "File esportato con successo.",
    "Invalid date": "Data non valida",
    "New Report Template": "Nuovo Modello di Report",
    "Edit Report Template": "Modifica Modello di Report",
    "Report Template Name": "Nome Modello di Report",
    "Description": "Descrizione",
    "Components": "Componenti",
    "Clone": "Clona",
    "An error occurred while saving {name}": "Si è verificato un errore durante il salvataggio di {{name}}",
    "{name} saved successfully": "{{name}} salvato con successo.",
    "Save": "Salva",
    "Time range: {fromDate} - {toDate}": "Intervallo di tempo: {{fromDate}} - {{toDate}}",
    "Printing instructions": "Istruzioni di stampa",
    "You will be prompted to print this page containing the report. Make sure you remove margins and include background graphics to properly render the document": "Ti verrà chiesto di stampare questa pagina contenente il report. Assicurati di rimuovere i margini e includere i grafici di sfondo per visualizzare correttamente il documento.",
    "Print": "Stampa",
    "Delete Report Template": "Elimina Modello di Report",
    "Are you sure you want to delete {name}": "Sei sicuro di voler eliminare {{name}}",
    "Delete": "Elimina",
    "Are you sure you want to remove report": "Sei sicuro di voler rimuovere il report",
    "Report removed successfully": "Report rimosso con successo",
    "ESG report": "Report ESG",
    "Not all values for the properties are completed": "Non tutti i valori per le proprietà sono completati",
    "Attention": "Attenzione",
    "An error occurred while removing report": "Si è verificato un errore durante la rimozione del report",
    "Processing": "Elaborazione in corso",
    "The report will be ready in a few minutes. You can come back to this page later to see it": "Il report sarà pronto tra qualche minuto, ritornare più tardi per la consultazione su questa pagina"
  },
  "settings": {
    "Settings": "Impostazioni",
    "Account": "Account",
    "Notifications": "Notifiche",
    "General": "Generale",
    "Users": "Utenti",
    "New User": "Nuovo Utente",
    "tabs": {
      "account": {
        "terms & conditions": "Termini e condizioni",
        "privacy notice": "ABB S.p.A. tratta i dati personali in particolare per garantirti l'accesso e contattarti. Per informazioni più dettagliate, compresi i diritti in materia di protezione dei dati, consulta <a href='https://new.abb.com/privacy-notice/it/informativa-sulla-privacy-abb' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>l'Informativa sulla privacy</a>.",
        "Profile Picture": "Immagine Profilo",
        "License": "Licenza",
        "Account Details": "Dettagli Account",
        "Upload/Change Your Profile": "Carica/Cambia il tuo Profilo",
        "Upload Avatar": "Carica Avatar",
        "remove": "rimuovi",
        "ID": "ID",
        "Assigned to": "Assegnato a",
        "Commissioning Activation Date": "Data di Attivazione",
        "Free Trial Activation": "Attivazione Prova Gratuita",
        "Current Status": "Stato Attuale",
        "Type": "Tipo",
        "Expiration date": "Data di Scadenza",
        "Under free trial period": "Periodo di prova gratuita",
        "TDB": "Da definire",
        "Renew": "Rinnova",
        "Change License": "Cambia Licenza",
        "Name": "Nome",
        "Surname": "Cognome",
        "Company / Legal Entity": "Azienda / Entità Legale",
        "Address": "Indirizzo",
        "Phone": "Telefono",
        "Country": "Paese",
        "City": "Città",
        "Postal Code": "CAP",
        "Email Address": "Indirizzo Email",
        "Change Details": "Modifica Dettagli",
        "Change Password": "Cambia Password",
        "Edit": "Modifica",
        "cancel": "annulla",
        "Save": "Salva",
        "Confirm": "Conferma",
        "Code for {attribute}": "Codice per {{attribute}}",
        "Confirmation code was sent to {deliveryMedium}": "Il codice di conferma è stato inviato a {{deliveryMedium}}",
        "Transfer Data": "Trasferisci Dati",
        "Transfer License": "Trasferisci Licenza",
        "Transfer owner license to": "Trasferisci la licenza proprietario a",
        "Search": "Cerca",
        "This field is required": "Questo campo è obbligatorio",
        "Old password": "Vecchia password",
        "New password": "Nuova password",
        "Confirm new password": "Conferma nuova password",
        "Confirm new password does not match": "La nuova password confermata non corrisponde.",
        "Password updated successfully": "Password aggiornata con successo.",
        "An error occurred while updating password": "Si è verificato un errore durante l'aggiornamento della password.",
        "An error occurred while updating user": "Si è verificato un errore durante l'aggiornamento dell'utente.",
        "An error occurred while transferring license to user {fullName}": "Si è verificato un errore durante il trasferimento della licenza all'utente {{fullName}}",
        "Password must be at least 8 characters long": "La password deve essere lunga almeno 8 caratteri.",
        "Password must not exceed 256 characters": "La password non deve superare i 256 caratteri.",
        "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "La password deve includere lettere maiuscole e minuscole, un numero e un carattere speciale (es. !@#$%^&*()).",
        "License {id} transferred successfully to user {name} {surname}": "Licenza {{id}} trasferita con successo all'utente {{name}} {{surname}}"
      },
      "notifications": {
        "Notifications": "Notifiche",
        "Specify how you would like to receive notifications": "Specifica come desideri ricevere le notifiche.",
        "Email": "Email",
        "In-app / Push Notifications": "Notifiche in-app / Push",
        "SMS": "SMS",
        "Critical events": "Eventi critici",
        "Information Events": "Eventi informativi",
        "System Events": "Eventi di sistema",
        "General information regarding the application (e.g. new upgrades, new functionalities, etc).": "Informazioni generali riguardanti l'applicazione (ad esempio, nuovi aggiornamenti, nuove funzionalità, ecc.).",
        "Notifications linked to alarms, automations and critical connection issues.": "Notifiche legate ad allarmi e problemi critici di connessione.",
        "General informative messages linked to non-critical connection issues.": "Messaggi informativi generali legati a problemi di connessione non critici."
      },
      "general": {
        "Region": "Regione",
        "Language": "Lingua",
        "System": "Sistema",
        "Country": "Paese",
        "Timezone": "Fuso orario",
        "Currency": "Valuta",
        "This field is required": "Questo campo è obbligatorio",
        "Change Region Settings": "Cambia Impostazioni Regione",
        "Edit": "Modifica",
        "cancel": "annulla",
        "Save": "Salva",
        "UI Aspect": "Aspetto UI",
        "ABB": "ABB",
        "Custom": "Personalizzato",
        "Theme color": "Colore tema",
        "Text color": "Colore testo",
        "Logo": "Logo",
        "Background color": "Colore sfondo",
        "English": "Inglese",
        "German": "Tedesco",
        "Italian": "Italiano",
        "French": "Francese",
        "Spanish": "Spagnolo",
        "Version of the app": "Versione dell'app",
        "Version": "Versione",
        "Latest SCU200 firmware": "Ultimo firmware SCU200",
        "Fw": "Fw",
        "Current SCU200 firmware status": "Stato attuale del firmware SCU200",
        "View details": "Visualizza dettagli",
        "SCU200 firmware update": "Aggiornamento firmware SCU200",
        "No data": "Nessun dato",
        "Updating": "Aggiornamento in corso",
        "Update available": "Aggiornamento disponibile",
        "Updated": "Aggiornato",
        "Update firmware": "Aggiorna firmware",
        "Please select a background color": "Per favore, seleziona un colore di sfondo.",
        "Please select a theme color": "Per favore, seleziona un colore per il tema.",
        "Please select a text color": "Per favore, seleziona un colore per il testo."
      },
      "users": {
        "Name": "Nome",
        "Surname": "Cognome",
        "Email": "Email",
        "Select Properties": "Seleziona Proprietà",
        "Role": "Ruolo",
        "Properties": "Proprietà",
        "Edit User": "Modifica Utente",
        "Remove User": "Rimuovi Utente",
        "New User": "Nuovo Utente",
        "Edit": "Modifica",
        "cancel": "annulla",
        "Create": "Crea",
        "Save": "Salva",
        "Admin": "Amministratore",
        "Advanced / Power User": "Utente Avanzato / Esperto",
        "View Only (Viewer)": "Solo Visualizzazione (Visualizzatore)",
        "Commissioner/Integrator": "Commissario/Integratore",
        "This field is required": "Questo campo è obbligatorio",
        "Email is not valid (e.g., user@example.com)": "L'email non è valida (es. user@example.com)",
        "Remove": "Rimuovi",
        "Are you sure you want to remove user": "Sei sicuro di voler rimuovere l'utente",
        "{name} was created successfully": "{{name}} è stato creato con successo.",
        "{name} was updated successfully": "{{name}} è stato aggiornato con successo.",
        "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
        "An error occurred while updating {name}": "Si è verificato un errore durante l'aggiornamento di {{name}}",
        "User deleted successfully": "Utente eliminato con successo.",
        "An error occurred while deleting the user": "Si è verificato un errore durante l'eliminazione dell'utente.",
        "End validity date": "Data di fine validità",
        "Category": "Categoria",
        "Viewer": "Visualizzatore",
        "Editing": "Modifica",
        "User with this email already exists": "Un utente con questa email esiste già",
        "Unable to proceed": "Impossibile continuare"
      },
      "user-logs": {
        "User Logs": "Log utente",
        "User": "utente",
        "Date": "data",
        "Action": "azione",
        "Object": "Oggetto",
        "id object": "id oggetto",
          "object": {
          "DASHBOARD": "Dashboard",
          "PROPERTY": "Proprietà",
          "USER": "Utente",
          "DEVICE": "Dispositivo",
          "ALARM": "Allarme",
          "AUTOMATION": "Automazione",
          "REPORT": "Rapporto",
          "GROUP": "Gruppo",
          "CONTRACT": "Contratto",
          "WIDGET": "Widget",
          "CONTROL": "Controllo",
          "REFRESH_DASHBOARD": "Aggiorna Dashboard",
          "LOGON": "Accesso"
          },
        "action": {
          "CREATE": "Crea",
          "UPDATE": "Aggiorna",
          "DELETE": "Elimina",
          "DUPLICATE": "Duplica",
          "LOGIN": "Accesso",
          "LOGOUT": "Disconnetti"
        },
        "create": "Creazione",
        "update": "Modifica",
        "delete": "Cancellazione"
      }
    }
  },
  "commons": {
    "No notifications to display": "Nessuna notifica da mostrare",
    "Are you sure?": "Sei sicuro?",
    "cancel": "annulla",
    "Confirm": "Conferma",
    "My Account": "Il mio account",
    "Logout": "Esci",
    "My Sites' Accounts": "Account dei miei siti",
    "An account with the given email or phone number already exists.": "Un account con l'email o il numero di telefono fornito esiste già.",
    "We encountered an issue while trying to send the verification code. Please check your email or phone number and try again.": "Abbiamo riscontrato un problema durante l'invio del codice di verifica. Controlla la tua email o numero di telefono e riprova.",
    "The code you entered is not valid. Please double-check the code and try again.": "Il codice inserito non è valido. Controlla il codice e riprova.",
    "An error occurred with the Cognito Identity Provider service.": "Si è verificato un errore con il servizio Cognito Identity Provider.",
    "Concurrent modification of the resource occurred.": "Si è verificata una modifica concorrente della risorsa.",
    "The provider is already linked to a user.": "Il provider è già collegato a un utente.",
    "Failed to enable software token MFA.": "Impossibile abilitare l'MFA con token software.",
    "The verification code you entered has expired. Please request a new code and try again.": "Il codice di verifica inserito è scaduto. Richiedi un nuovo codice e riprova.",
    "You do not have permission to perform this action.": "Non hai il permesso per eseguire questa azione.",
    "This group already exists.": "Questo gruppo esiste già.",
    "An internal error has occurred, please try again.": "Si è verificato un errore interno, riprova.",
    "The email role access policy is not valid.": "La policy di accesso per il ruolo email non è valida.",
    "Invalid response from the Lambda function.": "Risposta non valida dalla funzione Lambda.",
    "The specified OAuth flow is not valid.": "Il flusso OAuth specificato non è valido.",
    "Invalid parameter: Email format is incorrect.": "Parametro non valido: il formato dell'email è errato.",
    "Invalid parameter: Phone number format is incorrect. Please make sure to include your country code.": "Parametro non valido: il formato del numero di telefono è errato. Assicurati di includere il prefisso del tuo paese.",
    "Invalid parameter: Company must be 3-50 characters long.": "Parametro non valido: la ragione sociale deve avere tra 3 e 50 caratteri.",
    "Invalid parameter: Please check your input.": "Parametro non valido: controlla i dati inseriti.",
    "Invalid password: Password must be 8-256 characters long.": "Password non valida: la password deve avere tra 8 e 256 caratteri.",
    "Invalid password: Password must include uppercase letters.": "Password non valida: la password deve includere lettere maiuscole.",
    "Invalid password: Password must include lowercase letters.": "Password non valida: la password deve includere lettere minuscole.",
    "Invalid password: Password must include a number.": "Password non valida: la password deve includere un numero.",
    "Invalid password: Password must include a special character (e.g., !@#$%^&*()).": "Password non valida: la password deve includere un carattere speciale (ad esempio, !@#$%^&*()).",
    "Invalid password: Password must be 8-256 characters long, include uppercase and lowercase letters, a number, and a special character.": "Password non valida: la password deve avere tra 8 e 256 caratteri, includere lettere maiuscole e minuscole, un numero e un carattere speciale.",
    "The SMS role access policy is not valid.": "La policy di accesso per il ruolo SMS non è valida.",
    "The SMS role trust relationship is not valid.": "La relazione di fiducia del ruolo SMS non è valida.",
    "The user pool configuration is not valid.": "La configurazione del pool di utenti non è valida.",
    "Attempt limit exceeded, please try after some time.": "Limite di tentativi superato, riprova più tardi.",
    "The specified MFA method is not found.": "Il metodo MFA specificato non è stato trovato.",
    "Incorrect username or password.": "Nome utente o password errati.",
    "This password was used recently. Please choose a different password.": "Questa password è stata usata di recente. Scegli una password diversa.",
    "Password reset is required.": "È necessario reimpostare la password.",
    "A precondition for the request is not met.": "Una condizione necessaria per la richiesta non è stata soddisfatta.",
    "The requested resource was not found.": "La risorsa richiesta non è stata trovata.",
    "Risk configuration exception occurred.": "Si è verificata un'eccezione nella configurazione dei rischi.",
    "The specified scope does not exist.": "L'ambito specificato non esiste.",
    "The software token MFA is not found.": "Il token software MFA non è stato trovato.",
    "Too many failed attempts, please try again later.": "Troppi tentativi falliti, riprova più tardi.",
    "Too many requests, please try again later.": "Troppe richieste, riprova più tardi.",
    "The request is not authorized. This can happen due to an invalid access token.": "La richiesta non è autorizzata. Questo può accadere a causa di un token di accesso non valido.",
    "An unexpected error occurred with the Lambda function.": "Si è verificato un errore imprevisto con la funzione Lambda.",
    "The specified identity provider is not supported.": "Il provider di identità specificato non è supportato.",
    "The operation is not supported.": "L'operazione non è supportata.",
    "The specified token type is not supported.": "Il tipo di token specificato non è supportato.",
    "The user is in an unsupported state.": "L'utente si trova in uno stato non supportato.",
    "A user import job is in progress.": "Un'operazione di importazione utenti è in corso.",
    "The provided password does not meet the requirements.": "La password fornita non soddisfa i requisiti.",
    "User is not confirmed.": "L'utente non è confermato.",
    "User does not exist.": "L'utente non esiste.",
    "The user pool add-on is not enabled.": "L'add-on del pool utenti non è abilitato.",
    "The user pool tagging operation failed.": "L'operazione di tagging del pool utenti è fallita.",
    "An account with the given email already exists.": "Un account con l'email fornita esiste già.",
    "There is already a signed in user.": "C'è già un utente connesso.",
    "{count} items selected_one": "{{count}} elemento selezionato",
    "{count} items selected_other": "{{count}} elementi selezionati",
    "Edit": "Modifica",
    "Enable": "Abilita",
    "Disable": "Disabilita",
    "Delete": "Elimina",
    "Alarm": "Allarme",
    "Clone": "Clona",
    "Warning": "Avviso",
    "Unauthorized Access": "Accesso non autorizzato",
    "You do not have permission to view this page": "Non hai il permesso di visualizzare questa pagina",
    "Return to Home": "Torna alla Home",
    "An error occurred": "Si è verificato un errore",
    "Ok": "Ok"
  },
  "login": {
    "Don’t have an account? Sign-up": "Non hai un account? Registrati",
    "Reset mfa": "Reimposta mfa",
    "Forgot password": "Password dimenticata",
    "Reset Password": "Reimposta Password",
    "Back": "indietro",
    "Username": "Nome utente",
    "Confirmation Code": "Codice di conferma",
    "Confirmation code was sent by {deliveryMedium} to {deliveryDestination}": "Il codice di conferma è stato inviato tramite {{deliveryMedium}} a {{deliveryDestination}}",
    "Password has been successfully reset: you can now log in with your new password": "La password è stata reimpostata con successo: ora puoi accedere con la nuova password",
    "New Password": "Nuova Password",
    "Log in": "Accedi",
    "Login": "Accesso",
    "Email address": "Indirizzo email",
    "Password": "Password",
    "This field is required": "Questo campo è obbligatorio",
    "Email is not valid (e.g., user@example.com)": "L'email non è valida (es. user@example.com)",
    "Password is not valid": "La password non è valida",
    "Password must be at least 8 characters long": "La password deve essere lunga almeno 8 caratteri",
    "Password must not exceed 256 characters": "La password non deve superare i 256 caratteri",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "La password deve includere lettere maiuscole e minuscole, un numero e un carattere speciale (p.e., !@#$%^&*()).",
    "Confirm": "Conferma",
    "Code": "Codice",
    "Code is not valid": "Il codice non è valido",
    "Code has expired": "Il codice è scaduto",
    "Confirmation code is not valid": "Il codice di conferma non è valido",
    "Confirmation code has expired": "Il codice di conferma è scaduto",
    "Scan this QR code with your authenticator app to configure Two-Factor Authentication": "Scansiona questo codice QR utilizzando un’app di autenticazione (ad esempio Microsoft Authenticator o Google Authenticator) per configurare l’Autenticazione a Due Fattori per il tuo account. L’app scelta sarà il tuo metodo principale per accedere in modo sicuro all’applicazione.",
    "Please open your authenticator app and enter the verification code to continue": "Apri la tua app di autenticazione e inserisci il codice di verifica per continuare"
  },
  "signup": {
    "Account Registration": "Registrazione Account",
    "A confirmation code has been sent to your email. Please enter the code below to verify your account": "Un codice di conferma è stato inviato alla tua email. Inserisci il codice qui sotto per verificare il tuo account",
    "Next": "Avanti",
    "Back": "indietro",
    "Confirm": "Conferma",
    "Create Account": "Crea Account",
    "Name": "Nome",
    "Last name": "Cognome",
    "Company / Legal Entity": "Azienda / Ente Legale",
    "Country": "Paese",
    "City": "Città",
    "Postal Code": "CAP",
    "Address": "Indirizzo",
    "Phone": "Telefono",
    "Email address": "Indirizzo email",
    "Password": "Password",
    "Confirm Password": "Conferma Password",
    "Code": "Codice",
    "This field is required": "Questo campo è obbligatorio",
    "Email is not valid (e.g., user@example.com)": "L'email non è valida (es. user@example.com)",
    "Password is not valid": "La password non è valida",
    "Password must be at least 8 characters long": "La password deve essere lunga almeno 8 caratteri",
    "Password must not exceed 256 characters": "La password non deve superare i 256 caratteri",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "La password deve includere lettere maiuscole e minuscole, un numero e un carattere speciale (es. !@#$%^&*())",
    "Confirm Password does not match": "La password di conferma non corrisponde",
    "Postal Code is not valid": "Il CAP non è valido",
    "Phone is not valid (e.g., +39...)": "Il telefono non è valido (es. +39...)",
    "Accept terms & conditions": "Accetta i termini e le condizioni",
    "Minimum 3 characters are required": "Sono richiesti almeno 3 caratteri",
    "Maximum 50 characters allowed": "Sono consentiti al massimo 50 caratteri",
    "Leading and trailing spaces are not allowed": "Non sono consentiti spazi iniziali e finali",
    "Address is not valid": "L'indirizzo non è valido",
    "Email is already in use": "Questa email è già registrata. Utilizza un indirizzo email diverso o prova ad accedere.",
    "privacy notice": "ABB S.p.A. tratta i dati personali in particolare per garantirti l'accesso e contattarti. Per informazioni più dettagliate, compresi i diritti in materia di protezione dei dati, consulta <a href='https://new.abb.com/privacy-notice/it/informativa-sulla-privacy-abb' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>l'Informativa sulla privacy</a>."
  },
  "property_services": {
    "Property Services": "Servizi Immobiliari",
    "You are managing a total of {tot} devices, of which {connected} are «connected», {offline} «offline», {noCommunication} with no communication": "Stai gestendo un totale di {{tot}} dispositivi, di cui {{connected}} sono «connessi», {{offline}} «offline», {{noCommunication}} senza comunicazione",
    "Benchmarks": "Benchmark",
    "Energy Forecasting": "Previsioni Energetiche",
    "Costs & Tariffs": "Costi e Tariffe",
    "You have a total of {tot} devices": "Hai un totale di {{tot}} dispositivi",
    "{count} of which requires your _one": "{{count}} dei quali richiede la tua ",
    "{count} of which requires your _other": "{{count}} dei quali richiedono la tua ",
    "attention": "attenzione",
    "Add new contract": "Aggiungi nuovo contratto",
    "tabs": {
      "benchmarks": {
        "Select a benchmark to get started": "Seleziona un benchmark per iniziare",
        "Benchmark": "Benchmark",
        "Category": "Categoria",
        "Interval": "Intervallo",
        "Metric": "Metrica",
        "Resolution": "Risoluzione",
        "From": "Da",
        "To": "A",
        "cancel": "annulla",
        "Apply": "Applica",
        "Export": "Esporta",
        "File generated successfully": "File generato con successo",
        "An error occurred while generating export file": "Si è verificato un errore durante la generazione del file di esportazione",
        "BY_PROPERTIES": "Per proprietà",
        "BY_GROUPS": "Per gruppo",
        "BY_DEVICES": "Per tipo dispositivo"
      },
      "energy_forecasting": {},
      "costs_tariffs": {
        "Contract Name": "Nome Contratto",
        "Name": "Nome",
        "Tariff": "Tariffa",
        "Time": "Ora",
        "Devices": "Dispositivi",
        "Type": "Tipo",
        "Tag": "Tag",
        "to": "a",
        "Edit Contract": "Modifica Contratto",
        "Delete Contract": "Cancella Contratto",
        "Are you sure you want to remove contract": "Sei sicuro di voler rimuovere il contratto",
        "Remove": "Cancella",
        "Contract removed successfully": "Contratto rimosso con successo",
        "VIRTUAL": "virtual",
        "METER_MANAGED": "Meter managed",
        "side_panel": {
          "cancel": "annulla",
          "Save": "Salva",
          "Add contract": "Aggiungi contratto",
          "Contract configuration": "Configurazione contratto",
          "Name": "Nome",
          "Contract type": "Tipo di contratto",
          "Tag": "Tag",
          "Devices": "Dispositivi",
          "Tariffs": "Tariffe",
          "Cost": "Costo",
          "Apply": "Applica",
          "From": "Da",
          "To": "A",
          "Remove tariff": "Rimuovi tariffa",
          "No tariffs found": "Nessuna tariffa trovata",
          "New tariff": "Nuova tariffa",
          "Days": "Giorni",
          "From time": "Ora di inizio",
          "To time": "Ora di fine",
          "Contract updated": "Contratto aggiornato",
          "Contract created": "Contratto creato",
          "An error occurred while updating contract": "Si è verificato un errore durante l'aggiornamento del contratto",
          "An error occurred while creating contract": "Si è verificato un errore durante la creazione del contratto",
          "Some fields are not valid": "Alcuni campi non sono validi",
          "VIRTUAL": "Virtuale",
          "METER_MANAGED": "Gestita via meter",
          "End time must be after start time": "L'ora di fine deve essere dopo l'ora di inizio",
          "End date must be after start date": "La data di fine deve essere dopo la data di inizio"
        }
      }
    }
  },
  "alarms": {
    "Alarms": "Allarmi",
    "Alarms Logs": "Registro Allarmi",
    "New Alarm": "Nuovo Allarme",
    "You have a total of {tot} alarms, {totAlerts} of which requires your attention": "Hai un totale di {{tot}} allarmi, {{totAlerts}} dei quali richiede la tua attenzione",
    "tabs": {
      "list": {
        "New Alarm": "Nuovo Allarme",
        "Edit Alarm": "Modifica Allarme",
        "Name": "Nome",
        "Date": "Data",
        "Status": "Stato",
        "Condition": "Condizione",
        "Enabled": "Abilitato",
        "Properties": "Proprietà",
        "Groups": "Gruppi",
        "Properties / Groups": "Proprietà / Gruppi",
        "Devices": "Dispositivi",
        "Last update": "Ultimo aggiornamento",
        "Offline": "Offline",
        "Okay": "Ok",
        "In alarm": "In allarme",
        "Show with alarm only": "Mostra solo con allarme",
        "Edit": "Modifica",
        "Delete": "Elimina",
        "Remove": "Rimuovi",
        "remove": "rimuovere",
        "cancel": "annulla",
        "Create": "Crea",
        "Save": "Salva",
        "Enable": "Abilita",
        "enable": "abilitare",
        "Disable": "Disabilita",
        "disable": "disabilitare",
        "Apply": "Applica",
        "all selected items": "tutti gli elementi selezionati",
        "Please fill in all required fields before moving forward": "Compila tutti i campi obbligatori prima di procedere",
        "Are you sure that you want to {action}": "Sei sicuro di voler {{action}}",
        "Alarm {action} successfully": "Allarme {{action}} con successo",
        "An error occurred while {action} alarm": "Si è verificato un errore durante {{action}} dell'allarme",
        "Selected alarms are already {status}": "Gli allarmi selezionati sono già {{status}}",
        "Alarm deleted successfully": "Allarme eliminato con successo",
        "An error occurred while deleting the alarm": "Si è verificato un errore durante l'eliminazione dell'allarme",
        "enabled": "abilitato",
        "disabled": "disabilitato",
        "enabled_other": "abilitati",
        "disabled_other": "disabilitati",
        "enabling": "abilitazione",
        "disabling": "disabilitazione",
        "Select the type of asset you would like to create an alarm for": "Seleziona il tipo di risorsa per cui vuoi creare un allarme",
        "Select assets": "Seleziona Risorse",
        "Select Trigger Criteria": "Seleziona Criteri Attivazione",
        "Configure Notifications": "Configura Notifiche",
        "Add Name and Description": "Aggiungi Nome e Descrizione",
        "Conditions": "Condizioni",
        "Trigger": "Tipo di Trigger",
        "Statistic": "Statistica",
        "Period": "Periodo",
        "{metric} graph": "Grafico {{metric}}",
        "Metric": "Metrica",
        "currentTrms": "TRMS",
        "currentAc": "AC",
        "currentDc": "DC",
        "activePowerTotal": "Potenza effettiva",
        "activeEnergyTotal": "Energia effettiva",
        "Static": "Statico",
        "threshold": "soglia",
        "Use a value as a threshold": "Usa un valore come soglia",
        "Whenever {metric} is": "Ogni volta che {{metric}} è",
        "Define alarm condition": "Definisci la condizione dell'allarme",
        "delay": "Delay",
        "Define delay": "Definisci il delay",
        "CRITICAL": "Critico/a",
        "WARNING": "Attenzione",
        "than": "di",
        "Define threshold": "Definisci il valore soglia",
        "Must be a number": "Deve essere un numero",
        "Notification title": "Seleziona i contatti che desideri notificare quando questo allarme viene attivato",
        "Select Contact": "Seleziona Contatti",
        "Description": "Descrizione",
        "Search": "Cerca",
        "Next": "Successivo",
        "Back": "indietro",
        "{name} was created successfully": "{{name}} è stato creato con successo",
        "An error occurred while creating {name}": "Si è verificato un errore durante la creazione di {{name}}",
        "{name} was updated successfully": "{{name}} è stato aggiornato con successo",
        "An error occurred while updating {name}": "Si è verificato un errore durante l'aggiornamento di {{name}}"
      },
      "logs": {
        "Name": "Nome",
        "Date": "Data",
        "Start Date - End Date": "Data di inizio - Data di fine",
        "Status": "Stato",
        "Condition": "Condizione",
        "Enabled": "Abilitato",
        "Properties": "Proprietà",
        "Groups": "Gruppi",
        "Devices": "Dispositivi",
        "Offline": "Offline",
        "Okay": "Ok",
        "In alarm": "In allarme",
        "Start date": "Data di inizio",
        "End date": "Data di fine",
        "Apply": "Applica",
        "Show with alarm only": "Mostra solo con allarme",
        "Edit": "Modifica",
        "Delete": "Elimina",
        "cancel": "annulla",
        "Create": "Crea",
        "Enable": "Abilita",
        "Disable": "Disabilita",
        "Trigger Time": "Ora del Trigger",
        "Acknowledged By": "Riconosciuto da",
        "Category": "Categoria",
        "Do you confirm to set as acknowledged this alarm?": "Confermi di impostare questo allarme come riconosciuto?",
        "Set as acknowledged": "Imposta come riconosciuto",
        "Alarm acknowledged successfully": "L'allarme è stato riconosciuto con successo",
        "An error occurred while acknowledging alarm": "Si è verificato un errore durante il riconoscimento dell'allarme",
        "Export": "Esporta",
        "File exported successfully": "File esportato con successo",
        "An error occurred while exporting file": "Si è verificato un errore durante l'esportazione del file",
        "Please enter a date range": "Inserisci un intervallo di date"
      }
    }
  },
  "wizard_first_access": {
    "The setup wizard is currently in use. Please wait a moment and try again.": "Il wizard di configurazione è attualmente in uso. Attendere un momento e riprovare.",
    "privacy notice": "ABB S.p.A. tratta i dati personali in particolare per garantirti l'accesso e contattarti. Per informazioni più dettagliate, compresi i diritti in materia di protezione dei dati, consulta <a href='https://new.abb.com/privacy-notice/it/informativa-sulla-privacy-abb' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>l'Informativa sulla privacy</a>.",
    "Free trial period": "Periodo di prova gratuito",
    "Accept terms & conditions": "Accetta termini e condizioni",
    "As early user of the cloud application you will benefit from 12 months of unlimited device configuration... After 12 months you will have the freedom to decide using the application and purchase a license based on the N. of SCU200 connected or not using the cloud service anymore": "Come utente iniziale dell'applicazione cloud, beneficerai di 12 mesi di configurazione dispositivi illimitata... Dopo 12 mesi avrai la libertà di decidere di utilizzare l'applicazione e acquistare una licenza in base al numero di SCU200 connessi o di non utilizzare più il servizio cloud",
    "earlyUserBenefitsMessagePart1": "InSite Energy Pro offrirà agli utenti precoci 6 mesi di configurazione illimitata dei dispositivi gratuitamente!",
    "earlyUserBenefitsMessagePart2": "Dopo i 6 mesi:",
    "earlyUserBenefitsMessageItem1": "Per continuare a utilizzare il servizio, dovrà essere acquistata una licenza valida in base ai requisiti e alle esigenze specifiche.",
    "earlyUserBenefitsMessageItem2": "Gli utenti avranno la libertà di decidere se continuare con il servizio cloud.",
    "earlyUserBenefitsMessagePart3": "Per qualsiasi domanda o ulteriore informazione, non esitare a contattare il tuo rappresentante ABB locale.",
    "Next Step": "Passo Successivo",
    "Next": "Avanti",
    "Step": "Passo",
    "Add New Property": "Aggiungi Nuova Proprietà",
    "Gateway Connection": "Passo Successivo",
    "Devices Configuration": "Configurazione Dispositivi",
    "Final Summary": "Riepilogo Finale",
    "Token Generation": "Generazione Token",
    "Insert the following token in the SCU200 webserver for starting the linking process": "Inserisci il seguente token nel webserver SCU200 per avviare il processo di collegamento",
    "SCU200 Link": "Collegamento SCU200",
    "{name} Linked Successfully": "{{name}} Collegato con Successo",
    "Fw version": "Versione Firmware",
    "Do you want to update to the latest firmware": "Vuoi aggiornare all'ultimo firmware",
    "Yes": "Sì",
    "No": "No",
    "Latest firmware version updated": "Ultima versione firmware aggiornata",
    "Property {name}": "Proprietà {{name}}",
    "{name} connected": "{{name}} connesso",
    "Devices Configured": "Dispositivi Configurati",
    "back": "indietro",
    "Configure another gateway for this property": "Configura un altro SCU200",
    "Configure another property": "Configura un'altra proprietà",
    "All settled - Go to dashboard": "Termina",
    "Scan again": "Scansiona di nuovo",
    "Continue": "Continua",
    "You will have the chance to configure additional gateways or new properties also later on directly from the Dashboard": "Avrai la possibilità di configurare gateway o nuove proprietà aggiuntive anche successivamente direttamente dalla Dashboard",
    "Image": "Immagine",
    "Device": "Dispositivo",
    "Status": "Stato",
    "Category": "Categoria",
    "Property": "Proprietà",
    "Update firmware": "Aggiorna firmware",
    "Modbus ID": "ID Modbus",
    "Configure device": "Configura dispositivo",
    "cancel": "annulla",
    "Save": "Salva",
    "Please fill in all required fields before moving forward": "Compila tutti i campi obbligatori prima di procedere",
    "{count} devices connected_one": "{{count}} dispositivo connesso",
    "{count} devices connected_other": "{{count}} dispositivi connessi",
    "No response from the web server. Please check your internet connection or try again in a few minutes": "Nessuna risposta dal server web. Controlla la tua connessione internet o riprova tra qualche minuto",
    "Retry": "Riprova",
    "Waiting for webserver response": "In attesa della risposta del webserver",
    "Retry attempt {retryCount}": "Tentativo di ripristino {{retryCount}}",
    "Device configured successfully": "Dispositivo configurato con successo",
    "An error occurred while configuring device": "Si è verificato un errore durante la configurazione del dispositivo"
  },
  "error": {
    "connection_error": "Impossibile eseguire l'operazione a causa di problemi di connettività. Verifica l'accesso alla rete."
  },
  "common": {
    "GREATER": "Maggiore",
    "LOWER": "Minore",
    "GREATEREQUAL": "Maggiore/Uguale",
    "LOWEREQUAL": "Minore/Uguale",
    "ACTIVE_ENERGY": "Energia attiva",
    "APPARENT_ENERGY_NET": "Energia apparente netta",
    "ENERGY_KWH": "Energia attiva [kWh]",
    "ACTIVE_ENERGY_IMPORT": "Energia attiva importata",
    "ACTIVE_ENERGY_IMPORT_L1": "Energia attiva importata L1",
    "ACTIVE_ENERGY_IMPORT_L2": "Energia attiva importata L2",
    "ACTIVE_ENERGY_IMPORT_L3": "Energia attiva importata L3",
    "ACTIVE_ENERGY_EXPORT_L1": "Energia attiva esportata L1",
    "ACTIVE_ENERGY_EXPORT_L2": "Energia attiva esportata L2",
    "ACTIVE_ENERGY_EXPORT_L3": "Energia attiva esportata L3",
    "ACTIVE_ENERGY_NET_L1": "Energia attiva netta L1",
    "ACTIVE_ENERGY_NET_L2": "Energia attiva netta L2",
    "ACTIVE_ENERGY_NET_L3": "Energia attiva netta L3",
    "REACTIVE_ENERGY_EXPORT_L1": "Energia reattiva netta esportata L1",
    "REACTIVE_ENERGY_EXPORT_L2": "Energia reattiva netta esportata L2",
    "REACTIVE_ENERGY_EXPORT_L3": "Energia reattiva netta esportata L3",
    "REACTIVE_ENERGY_IMPORT_L1": "Energia reattiva netta importata L1",
    "REACTIVE_ENERGY_IMPORT_L2": "Energia reattiva netta importata L2",
    "REACTIVE_ENERGY_IMPORT_L3": "Energia reattiva netta importata L3",
    "REACTIVE_ENERGY_NET_L1": "Energia reattiva netta L1",
    "REACTIVE_ENERGY_NET_L2": "Energia reattiva netta L2",
    "REACTIVE_ENERGY_NET_L3": "Energia reattiva netta L3",
    "TOTAL_COST_EUR": "Costo totale [€]",
    "ACTIVE_IMPORT_TOTAL": "Importazione attiva totale",
    "ACTIVE_EXPORT_TOTAL": "Esportazione attiva totale",
    "REACTIVE_IMPORT_TOTAL": "Importazione reattiva totale",
    "REACTIVE_EXPORT_TOTAL": "Esportazione reattiva totale",
    "INSITE_BUS": "InSite Bus",
    "METERING_MODULES": "Metering modules",
    "WIRELESS_M_BUS": "Wireless M-Bus",
    "USB_DEVICE": "USB device",
    "MODBUS_RTU_RS485_DEVICES": "Modbus RTU RS485 devices",
    "MODBUS_TCP_DEVICES": "Modbus TCP devices",
    "CURRENT_SENSOR": "Sensore di corrente",
    "ENERGY_METER": "Energy Meter",
    "I_O_MODULE": "I/O module",
    "INS_S_H": "INS-S/H",
    "MODBUS": "Modbus",
    "SCU200": "SCU200",
    "METER_W_MBUS": "Meter WMBus",
    "METER_LINKY": "Meter Linky",
    "METER_P1": "Meter P1",
    "THIRD_PARTY_RTU": "Third Party RTU",
    "THIRD_PARTY_TCP": "Third Party TCP",
    "TRMS_A": "TRMS [A]",
    "AC_A": "AC [A]",
    "DC_A": "DC [A]",
    "ACTIVE_POWER_TOTAL_W": "Potenza attiva totale [W]",
    "ACTIVE_ENERGY_TOTAL_WH": "Energia attiva totale [kWh]",
    "PORT1_STATUS_CHANGE_COUNTER": "Contatore cambiamento stato porta 1",
    "PORT2_STATUS_CHANGE_COUNTER": "Contatore cambiamento stato porta 2",
    "PORT3_STATUS_CHANGE_COUNTER": "Contatore cambiamento stato porta 3",
    "PORT4_STATUS_CHANGE_COUNTER": "Contatore cambiamento stato porta 4",
    "PORT1_PULSE_COUNTER_ACCUMULATED": "Contatore impulsi accumulati porta 1",
    "PORT2_PULSE_COUNTER_ACCUMULATED": "Contatore impulsi accumulati porta 2",
    "PORT3_PULSE_COUNTER_ACCUMULATED": "Contatore impulsi accumulati porta 3",
    "PORT4_PULSE_COUNTER_ACCUMULATED": "Contatore impulsi accumulati porta 4",
    "PORT1_PULSE_COUNTER_ACCUMULATED_VALUE": "Valore accumulato contatore impulsi porta 1",
    "PORT2_PULSE_COUNTER_ACCUMULATED_VALUE": "Valore accumulato contatore impulsi porta 2",
    "PORT3_PULSE_COUNTER_ACCUMULATED_VALUE": "Valore accumulato contatore impulsi porta 3",
    "PORT4_PULSE_COUNTER_ACCUMULATED_VALUE": "Valore accumulato contatore impulsi porta 4",
    "PORT1_STATE": "Stato porta 1",
    "PORT2_STATE": "Stato porta 2",
    "PORT3_STATE": "Stato porta 3",
    "PORT4_STATE": "Stato porta 4",
    "SWITCH_1": "Interruttore 1",
    "SWITCH_2": "Interruttore 2",
    "TEMPERATURE_1_C": "Temperatura 1 [°C]",
    "TEMPERATURE_2_C": "Temperatura 2 [°C]",
    "TEMPERATURE_3_C": "Temperatura 3 [°C]",
    "TEMPERATURE_4_C": "Temperatura 4 [°C]",
    "INPUT_VOLTAGE_V": "Tensione di ingresso [V]",
    "VOLTAGE_L1_V": "Tensione L1 [V]",
    "VOLTAGE_L2_V": "Tensione L2 [V]",
    "VOLTAGE_L3_V": "Tensione L3 [V]",
    "VOLTAGE_L1_L2_V": "Tensione L1-L2 [V]",
    "VOLTAGE_L3_L2_V": "Tensione L3-L2 [V]",
    "VOLTAGE_L1_L3_V": "Tensione L1-L3 [V]",
    "CURRENT_L1_A": "Corrente L1 [A]",
    "CURRENT_L2_A": "Corrente L2 [A]",
    "CURRENT_L3_A": "Corrente L3 [A]",
    "CURRENT_N_A": "Corrente N [A]",
    "ACTIVE_POWER_L1_W": "Potenza attiva L1 [W]",
    "ACTIVE_POWER_L2_W": "Potenza attiva L2 [W]",
    "ACTIVE_POWER_L3_W": "Potenza attiva L3 [W]",
    "REACTIVE_POWER_L1_VAR": "Potenza reattiva L1 [VAR]",
    "REACTIVE_POWER_L2_VAR": "Potenza reattiva L2 [VAR]",
    "REACTIVE_POWER_L3_VAR": "Potenza reattiva L3 [VAR]",
    "APPARENT_POWER_L1_VA": "Potenza apparente L1 [VA]",
    "APPARENT_POWER_L2_VA": "Potenza apparente L2 [VA]",
    "APPARENT_POWER_L3_VA": "Potenza apparente L3 [VA]",
    "FREQUENCY_HZ": "Frequenza [Hz]",
    "CURRENT_QUADRANT_L1": "Quadrante corrente L1",
    "CURRENT_QUADRANT_L2": "Quadrante corrente L2",
    "CURRENT_QUADRANT_L3": "Quadrante corrente L3",
    "POWER_FACTOR_L1": "Fattore di potenza L1",
    "POWER_FACTOR_L2": "Fattore di potenza L2",
    "POWER_FACTOR_L3": "Fattore di potenza L3",
    "POWER_FACTOR_TOTAL": "Fattore di potenza totale",
    "REACTIVE_POWER_TOTAL_VAR": "Potenza reattiva totale [VAR]",
    "APPARENT_POWER_TOTAL_VA": "Potenza apparente totale [VA]",
    "COS_PHI_L1": "Cos φ L1",
    "COS_PHI_L2": "Cos φ L2",
    "COS_PHI_L3": "Cos φ L3",
    "COS_PHI_3_PHASE": "Cos φ trifase",
    "CTL1_L2_L3_RATIO_DENOMINATOR": "Denominatore rapporto CTL1 L2-L3",
    "CURRENT_QUADRANT_TOTAL": "Quadrante corrente totale",
    "ACTIVE_ENERGY_NET_TOTAL": "Energia attiva netta totale",
    "REACTIVE_ENERGY_EXPORT_TOTAL": "Energia reattiva esportata totale",
    "ACTIVE_ENERGY_CO2": "Energia attiva CO2",
    "REACTIVE_ENERGY_IMPORT_TOTAL": "Energia reattiva importata totale",
    "ACTIVE_ENERGY_CURRENCY": "Valuta energia attiva",
    "ACTIVE_ENERGY_IMPORT_TOTAL": "Energia attiva importata totale",
    "APPARENT_ENERGY_NET_TOTAL": "Energia apparente netta totale",
    "APPARENT_ENERGY_NET_L2": "Energia apparente netta L2",
    "ACTIVE_ENERGY_EXPORT_TOTAL": "Energia attiva esportata totale",
    "APPARENT_ENERGY_NET_L1": "Energia apparente netta L1",
    "REACTIVE_ENERGY_NET_TOTAL": "Energia reattiva netta totale",
    "APPARENT_ENERGY_NET_L3": "Energia apparente netta L3",
    "POWER_ANGLE_POWER_L1": "Angolo di potenza L1",
    "POWER_ANGLE_POWER_L2": "Angolo di potenza L2",
    "POWER_ANGLE_POWER_L3": "Angolo di potenza L3",
    "POWER_ANGLE_POWER_TOTAL": "Angolo di potenza totale",
    "PHASE_ANGLE_VOLTAGE_L1": "Angolo di fase tensione L1",
    "PHASE_ANGLE_VOLTAGE_L2": "Angolo di fase tensione L2",
    "PHASE_ANGLE_VOLTAGE_L3": "Angolo di fase tensione L3",
    "PHASE_ANGLE_CURRENT_L1": "Angolo di fase corrente L1",
    "PHASE_ANGLE_CURRENT_L2": "Angolo di fase corrente L2",
    "PHASE_ANGLE_CURRENT_L3": "Angolo di fase corrente L3",
    "CURRENT_HARMONICS_THD_L1": "Distorsione armonica totale corrente L1",
    "CURRENT_HARMONICS_THD_L2": "Distorsione armonica totale corrente L2",
    "CURRENT_HARMONICS_THD_L3": "Distorsione armonica totale corrente L3",
    "CURRENT_HARMONICS_THD_N": "Distorsione armonica totale corrente N",
    "VOLTAGE_HARMONICS_THD_L1": "Distorsione armonica totale tensione L1",
    "VOLTAGE_HARMONICS_THD_L2": "Distorsione armonica totale tensione L2",
    "VOLTAGE_HARMONICS_THD_L3": "Distorsione armonica totale tensione L3",
    "ACTIVE_POWER_IMPORT_W": "Potenza attiva importata [W]",
    "REACTIVE_POWER_IMPORT_VAR": "Potenza reattiva importata [VAR]",
    "ACTIVE_POWER_EXPORT_W": "Potenza attiva esportata [W]",
    "REACTIVE_POWER_EXPORT_VAR": "Potenza reattiva esportata [VAR]",
    "APPARENT_POWER_IMPORT_TOTAL_VA": "Potenza apparente importata totale [VA]",
    "APPARENT_POWER_IMPORT_L1_VA": "Potenza apparente importata L1 [VA]",
    "APPARENT_POWER_IMPORT_L2_VA": "Potenza apparente importata L2 [VA]",
    "APPARENT_POWER_IMPORT_L3_VA": "Potenza apparente importata L3 [VA]",
    "ACTIVE_POWER_IMPORT_TOTAL_W": "Potenza attiva importata totale [W]",
    "ACTIVE_POWER_TOTAL_KW": "Potenza attiva totale [kW]",
    "ACTIVE_POWER_IMPORT_L1_W": "Potenza attiva importata L1 [W]",
    "ACTIVE_POWER_IMPORT_L2_W": "Potenza attiva importata L2 [W]",
    "ACTIVE_POWER_IMPORT_L3_W": "Potenza attiva importata L3 [W]",
    "ACTIVE_POWER_EXPORT_TOTAL_W": "Potenza attiva esportata totale [W]",
    "ACTIVE_POWER_EXPORT_L1_W": "Potenza attiva esportata L1 [W]",
    "ACTIVE_POWER_EXPORT_L2_W": "Potenza attiva esportata L2 [W]",
    "ACTIVE_POWER_EXPORT_L3_W": "Potenza attiva esportata L3 [W]",
    "REACTIVE_POWER_IMPORT_TOTAL_VAR": "Potenza reattiva importata totale [VAR]",
    "REACTIVE_POWER_IMPORT_L1_VAR": "Potenza reattiva importata L1 [VAR]",
    "REACTIVE_POWER_IMPORT_L2_VAR": "Potenza reattiva importata L2 [VAR]",
    "REACTIVE_POWER_IMPORT_L3_VAR": "Potenza reattiva importata L3 [VAR]",
    "REACTIVE_POWER_EXPORT_TOTAL_VAR": "Potenza reattiva esportata totale [VAR]",
    "REACTIVE_POWER_EXPORT_L1_VAR": "Potenza reattiva esportata L1 [VAR]",
    "REACTIVE_POWER_EXPORT_L2_VAR": "Potenza reattiva esportata L2 [VAR]",
    "REACTIVE_POWER_EXPORT_L3_VAR": "Potenza reattiva esportata L3 [VAR]",
    "THREE_PHASE_SYSTEM_VOLTAGE_V": "Tensione sistema trifase [V]",
    "THREE_PHASE_SYSTEM_CURRENT_A": "Corrente sistema trifase [A]",
    "PORT1_STATUS_CHANGE": "Cambiamenti stato porta 1",
    "PORT2_STATUS_CHANGE": "Cambiamenti stato porta 2",
    "PORT3_STATUS_CHANGE": "Cambiamenti stato porta 3",
    "PORT4_STATUS_CHANGE": "Cambiamenti stato porta 4",
    "ACTIVE_ENERGY_EXPORT_TOTAL_KWH": "Energia attiva esportata totale [kWh]",
    "ACTIVE_ENERGY_IMPORT_TOTAL_KWH": "Energia attiva importata totale [kWh]",
    "ACTIVE_ENERGY_NET_TOTAL_KWH": "Energia attiva netta totale [kWh]",
    "APPARENT_ENERGY_NET_L1_KWH": "Energia apparente netta L1 [kWh]",
    "APPARENT_ENERGY_NET_L2_KWH": "Energia apparente netta L2 [kWh]",
    "APPARENT_ENERGY_NET_L3_KWH": "Energia apparente netta L3 [kWh]",
    "APPARENT_ENERGY_NET_TOTAL_KWH": "Energia apparente netta totale [kWh]",
    "REACTIVE_ENERGY_EXPORT_TOTAL_KWH": "Energia reattiva netta esportata totale [kWh]",
    "REACTIVE_ENERGY_IMPORT_TOTAL_KWH": "Energia reattiva netta importata totale [kWh]",
    "REACTIVE_ENERGY_NET_TOTAL_KWH": "Energia reattiva netta totale [kWh]",
    "SYSTEM": "Sistema",
    "CROSS_UP": "Cross-Up",
    "CROSS_DOWN": "Cross-Down",
    "STATUS_CHANGE": "Cambio di stato",
    "ACTIVE_POWER_TOTAL": "Potenza attiva totale",
    "COMMUNICATION_FAILURE": "Guasto di comunicazione",
    "COMMUNICATION_RESTORE": "Ripristino comunicazione",
    "STATUS_CHANGE_TO_CLOSED": "Cambio di stato a chiuso",
    "STATUS_CHANGE_TO_OPEN": "Cambio di stato a aperto",
    "AUTOMATION_SUCCESS": "Automazione riuscita",
    "AUTOMATION_FAILURE": "Automazione fallita",
    "VALUE_MATCH": "Corrispondenza valore",
    "STATUS_CHANGE_TO_ON": "Cambio di stato a acceso",
    "STATUS_CHANGE_TO_OFF": "Cambio di stato a spento",
    "VALUE_CHANGE": "Cambiamento valore",
    "OPEN": "Apri",
    "CLOSE": "Chiudi",
    "GOOD": "Buono",
    "TO_BE_IMPROVED": "Da migliorare",
    "CONSUMPTION": "Consumi",
    "TOTAL_COST": "Costo",
    "ACTIVE_ENERGY_EXPORT": "Energia attiva esportata",
    "ACTIVE_ENERGY_NET": "Energia attiva netta",
    "APPARENT_ENERGY_EXPORT": "Energia apparente esportata",
    "APPARENT_ENERGY_IMPORT": "Energia apparente importata",
    "REACTIVE_ENERGY_NET": "Energia reattiva netta",
    "REACTIVE_ENERGY_IMPORT": "Energia reattiva netta importata",
    "REACTIVE_ENERGY_EXPORT": "Energia reattiva netta esportata",
    "GAS_CONSUMPTION": "Gas Consumption",
    "WATER_CONSUMPTION": "Water Consumption",
    "CHARGING_STATE": "Stato di carica",
    "FIRMWARE_VERSION": "Versione Firmware",
    "INPUT_1_COUNTER": "Input 1 Counter",
    "INPUT_2_COUNTER": "Input 2 Counter",
    "INPUT_3_COUNTER": "Input 3 Counter",
    "INPUT_4_COUNTER": "Input 4 Counter",
    "INPUT_3_CURRENT_STATE": "Input 3 Current State",
    "INPUT_3_STORED": "Input 3 Stored",
    "INPUT_4_CURRENT_STATE": "Input 4 Current State",
    "INPUT_4_STORED": "Input 4 Stored",
    "MESSAGE1": "Messaggio 1",
    "MESSAGE2": "Messaggio 2",
    "OUTPUT_1": "Output 1",
    "OUTPUT_2": "Output 2",
    "OUTPUT_3": "Output 3",
    "OUTPUT_4": "Output 4",
    "REFERENCE_APPARENT_POWER": "Potenza apparente di riferimento",
    "REFERENCE_BREAKING_CAPACITY": "Capacità di interruzione di riferimento",
    "RELAY1": "Relè 1",
    "RELAY2": "Relè 2",
    "RELAY3": "Relè 3",
    "RELAY4": "Relè 4",
    "RELAY5": "Relè 5",
    "RELAY6": "Relè 6",
    "RELAY7": "Relè 7",
    "RELAY8": "Relè 8",
    "SERIAL_NUMBER": "Numero di serie",
    "SOCKET_LOCK_STATE": "Socket Lock State",
    "STATUS_REGISTER": "Registro di stato",
    "VOLTAGE_HARMONICS_THD_L1_L2": "Armoniche di tensione THD L1-L2",
    "VOLTAGE_HARMONICS_THD_L2_L3": "Armoniche di tensione THD L2-L3",
    "VOLTAGE_HARMONICS_THD_L3_L2": "Armoniche di tensione THD L3-L2",
    "VOLTAGE_HARMONICS_THD_L1_L3": "Armoniche di tensione THD L1-L3",
    "PHASE_ANGLE_POWER_L1": "Angolo di fase potenza L1",
    "PHASE_ANGLE_POWER_L2": "Angolo di fase potenza L2",
    "PHASE_ANGLE_POWER_L3": "Angolo di fase potenza L3",
    "PHASE_ANGLE_POWER_TOTAL": "Angolo di fase potenza totale",
    "ACTIVE_POWER_L1": "Potenza attiva L1",
    "ACTIVE_POWER_L2": "Potenza attiva L2",
    "ACTIVE_POWER_L3": "Potenza attiva L3",
    "APPARENT_ENERGY_EXPORT_L1": "Esportazione di energia apparente L1",
    "APPARENT_ENERGY_EXPORT_L2": "Esportazione di energia apparente L2",
    "APPARENT_ENERGY_EXPORT_L3": "Esportazione di energia apparente L3",
    "APPARENT_ENERGY_EXPORT_TOTAL": "Esportazione di energia apparente totale",
    "APPARENT_ENERGY_IMPORT_L1": "Importazione di energia apparente L1",
    "APPARENT_ENERGY_IMPORT_L2": "Importazione di energia apparente L2",
    "APPARENT_ENERGY_IMPORT_L3": "Importazione di energia apparente L3",
    "APPARENT_ENERGY_IMPORT_TOTAL": "Importazione di energia apparente totale",
    "APPARENT_POWER_TOTAL": "Potenza apparente totale",
    "APPARENT_POWER_L1":" Potenza apparente L1",
    "APPARENT_POWER_L2":" Potenza apparente L2",
    "APPARENT_POWER_L3":" Potenza apparente L3",
    "REACTIVE_POWER_L1": "Potenza reattiva L1",
    "REACTIVE_POWER_L2": "Potenza reattiva L2",
    "REACTIVE_POWER_L3": "Potenza reattiva L3",
    "REACTIVE_POWER_TOTAL": "Potenza reattiva totale",
    "ACTIVE_ENERGY_EXPORT_L1_KWH": "Esportazione di energia attiva L1 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L2_KWH": "Esportazione di energia attiva L2 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L3_KWH": "Esportazione di energia attiva L3 [kWh]"
  }
}
